import React from 'react';
import { useInView } from 'react-intersection-observer';
import {AiFillGithub, AiFillLinkedin} from 'react-icons/ai';


import IntroB from '../Reponsywne/LewyObiektPelny';
import ObAnimated from '../Zanimowane/Animated';
import Obrazek from '../Zanimowane/Obrazek';

export default function SekcjaThird() {

    const {ref, inView} = useInView();


    return (

        <div className='flex justify-between' ref={ref}>
            <div>
            <ObAnimated referencja={inView} czyZanimowane={true}>
                <IntroB tytul={"Contact"} fontSize={85} refer={inView} button={false} czyZanimowane={true}>
                    <p className={'text-[24px]'}><a className='absolute bottom-[100%] mb-5 hover:opacity-50 transition-all duration-200' href='mailto:jakub.bbednarek32@gmail.com'>jakub.bbednarek32@gmail.com</a></p>
                    <div className='flex items-center space-x-[2rem] mt-12'>
                    <a href='https://github.com/Destray32/' className='hover:opacity-50 transition-all duration-200'>
                        <AiFillGithub size={34} />
                    </a>

                    <a href='https://www.linkedin.com/in/jakub-bednarek-79a5bb243/' className='hover:opacity-50 transition-all duration-200'>
                        <AiFillLinkedin size={34} />
                    </a>
                </div>
                </IntroB>
            </ObAnimated>
            </div>

            <div>
                <Obrazek referencja={inView} urlObrazka={"fala3.jpg"}/>
            </div>
        </div>

    )

}